export const LOCALES = {
  ENGLISH: "en-US",
  TURKISH: "tr-TR",
};
